import React, {useState, useRef, useContext} from 'react';
import ChantierInfoFileView from './ChantierInfoFileView';
import moment from 'moment/moment';
import {getFiles} from '../../../services/MadricService';
import {useParams} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../../Context/MadricContext';
import Spinner from '../../Spinner/Spinner';

/**
 * Affiche l'historique des checkins et des photos d'un chantier
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoFile() {
  const navigate = useNavigate();

  const {projectInfoObtained, projectInfo, setProjectInfo} = useContext(MadricContext);

  const [imageOnScreen, setImageOnScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [filteredArray, setFilteredArray] = useState([]);
  const filterForm = useRef({inputRef: '',
    dateRef: '',
    extra1: false,
    extra2: false,
    extra3: false});

  const {id} = useParams();

  const fileRef = useRef();

  /**
   * Permet d'allez chercher la liste de fichier
   */
  async function getAllFiles() {
    setImageOnScreen(true);
    if (!projectInfoObtained.current.includes('file')) {
      setIsLoading(true);
      const files = await getFiles(id);

      files.sort((a, b) => {
        const dateCompare = b.date.localeCompare(a.date);
        if (dateCompare !== 0) {
          return dateCompare;
        }

        return b.user_id - a.user_id;
      });
      setProjectInfo((prev) => [...prev, ...files]);
      setFilteredArray(files);
      projectInfoObtained.current = [...projectInfoObtained.current, 'file'];
      setIsLoading(false);
    } else {
      setFilteredArray(projectInfo.filter((item) => item.type === 'file'));
    }
  }

  /**
   * Supprime le filtre de la date
   */
  function removeDate() {
    filterForm.current = {
      ...filterForm.current,
      dateRef: '',
    };
    filterData();
  }


  /**
   * Permet de filtrer par le nom
   * @param {*} event event
   */
  function handleChange(event) {
    filterForm.current = {
      ...filterForm.current,
      inputRef: event.target.value,
    };
    filterData();
  }

  /**
   * Permet de handle les checkbox
   * @param {*} event event
   */
  function handleCheckboxChange(event) {
    filterForm.current = {
      ...filterForm.current,
      [event.target.name]: event.target.checked,
    };
    filterData();
  }

  /**
   * filtre de la date
   * @param {*} event event
   */
  function handleDateChange(event) {
    filterForm.current = {
      ...filterForm.current,
      dateRef: event,
    };
    filterData();
  }

  /**
   * Permet de naviguer vers la page d'ajout de fichier
   */
  function addFile() {
    navigate('/addFile', {state: {id}});
  }

  const filterExtra = (item1, item2, item3) => {
    const {extra1, extra2, extra3} = filterForm.current;

    const areAllExtrasFalse = !extra1 && !extra2 && !extra3;
    const isItem1Matching = item1 === extra1 && item1;
    const isItem2Matching = item2 === extra2 && item2;
    const isItem3Matching = item3 === extra3 && item3;

    return areAllExtrasFalse || isItem1Matching || isItem2Matching || isItem3Matching;
  };


  const filterData = () => {
    const dateRef = filterForm.current.dateRef;
    const filteredArrays = projectInfo.filter((item) => item.type === 'file').filter((item) => {
      const date1 = moment.tz(item.date, 'America/Montreal');
      const date2 = moment.tz(dateRef, 'America/Montreal');

      return (item.name.toLowerCase().includes(filterForm.current.inputRef) &&
        (date1.isSame(date2) || dateRef === '') &&
        filterExtra(item.extra1, item.extra2, item.extra3));
    });

    setFilteredArray(filteredArrays);
  };

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <ChantierInfoFileView
        addFile={addFile}
        imageOnScreen={imageOnScreen}
        filteredArray={filteredArray}
        getFiles={getAllFiles}
        handleChange={handleChange}
        handleDateChange={handleDateChange}
        dateRef={filterForm.current.dateRef}
        handleCheckboxChange={handleCheckboxChange}
        removeDate={removeDate}
        fileRef={fileRef.current}
      />
    </React.Fragment>
  );
}

export default ChantierInfoFile;
